import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import FooterSection from './FooterSection';

const LandingLayout: React.FC = () => {
  const location = useLocation();

  const scrollToSection = (targetId: string) => {
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Handle scroll to section when hash changes
  React.useEffect(() => {
    if (location.hash) {
      // Remove the # from the hash
      const targetId = location.hash.slice(1);
      // Add a small delay to ensure the page has rendered
      setTimeout(() => {
        scrollToSection(targetId);
      }, 100);
    } else {
      // If no hash and we've navigated to a new page, scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location.pathname, location.hash]);

  return (
    <div className="min-h-screen bg-white">
      {/* Main Content */}
      <main>
        <Outlet />
      </main>

      {/* Footer */}
      <FooterSection />
    </div>
  );
};

export default LandingLayout;
